<template>
  <div class="box">
    <label for="regularValue">Calculate Numerology Values</label><br />
    <br />
    <input type="text" name="regularValue" v-model="inputValue" placeholder="Type here to calculate" />
    <p class="centered">
      <span class="calculated">{{calculatedValues.totalValue}}&nbsp;Total Value</span><br />
      <span class="calculated">{{calculatedValues.reducedValue}}&nbsp;Reduced Value</span>
    </p>
  </div>
</template>
<script>
export default {
  name: 'Numerology',
  data () {
    return {
      inputValue: ''
    }
  },
  computed: {
    calculatedValues: function () {
      let tv = 0
      let rv = 0

      if (this.inputValue === null || this.inputValue === undefined) {
        return {
          totalValue: tv,
          reducedValue: rv
        }
      }

      let reLetters = /[A-Za-z]+/gi
      let reDigits = /\d+/g
      let allLetters = this.inputValue.match(reLetters)
      let allDigits = this.inputValue.match(reDigits)
      const lowerCaseMin = 96
      const upperCaseMin = 64

      if (allLetters !== null) {
        for (let x = 0; x < allLetters.length; x++) {
          let li = allLetters[x]
          for (let y = 0; y < li.length; y++) {
            let lc = li.charCodeAt(y)
            let mod = 0
            if (lc > lowerCaseMin) { mod = lc - lowerCaseMin } else { mod = lc - upperCaseMin }
            tv += mod
          }
        }
      }

      if (allDigits !== null) {
        for (let x = 0; x < allDigits.length; x++) {
          let li = allDigits[x]
          for (let y = 0; y < li.length; y++) {
            let mod = parseInt(li.charAt(y))
            tv += mod
          }
        }
      }

      rv = tv
      let rvStr = '' + rv
      while (rvStr.length > 1) {
        rv = 0
        for (let x = 0; x < rvStr.length; x++) {
          rv += parseInt(rvStr.charAt(x))
        }
        rvStr = '' + rv
      }

      return {
        totalValue: tv,
        reducedValue: rv
      }
    }
  }
}
</script>
<style scoped>
  input[type="text"] {
    width: 100%;
    max-width: 20em;
  }
  .box {
    margin-left: auto;
    margin-right: auto;
    padding: 5px;
    width: 50%;
    border: 1px #000 solid;
    margin-top: 10px;
  }
  .calculated {
    font-weight: bold;
  }
  .centered {
    margin-left: auto;
    margin-right: auto;
    text-align: center;
  }
</style>
